import { render, staticRenderFns } from "./TTMultiselectGroup.vue?vue&type=template&id=60761e9c&scoped=true"
import script from "./TTMultiselectGroup.vue?vue&type=script&lang=js"
export * from "./TTMultiselectGroup.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TTMultiselectGroup.vue?vue&type=style&index=1&id=60761e9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60761e9c",
  null
  
)

export default component.exports